import that from '../utilities/translationHelper'

const temperatureTypes = {
	CELSIUS: {
		type: 'CELSIUS',
		fromOtherTemperature: value => (typeof value !== 'undefined' ? Math.round((value - 32) * (5 / 9)) : value),
		name: that.context.translate('Celsius'),
		shortName: that.context.translate('°c')
	},
	FAHRENHEIT: {
		type: 'FAHRENHEIT',
		fromOtherTemperature: value => (typeof value !== 'undefined' ? Math.round(value * (9 / 5) + 32) : value),
		name: that.context.translate('Fahrenheit'),
		shortName: that.context.translate('°f')
	}
}

export default temperatureTypes



// WEBPACK FOOTER //
// ./src/enums/temperatureTypes.js